const SERVER_ERROR_NAME = 'ServerError'

export default SERVER_ERROR_NAME
